import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPipeline = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		d: "M21 19.5V23.25",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9 6.75H8.25C7.65326 6.75 7.08097 6.98705 6.65901 7.40901C6.23705 7.83097 6 8.40326 6 9C6 9.59674 6.23705 10.169 6.65901 10.591C7.08097 11.0129 7.65326 11.25 8.25 11.25H13.5C15.0956 11.2519 16.6491 11.7618 17.9355 12.7057C19.2219 13.6496 20.1744 14.9785 20.655 16.5",
		fill: "none",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M20.25 6.75H12",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12 2.25H20.25",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.482 16.5C14.9353 16.016 14.2302 15.7492 13.5 15.75H8.25C6.45979 15.75 4.7429 15.0388 3.47703 13.773C2.21116 12.5071 1.5 10.7902 1.5 9C1.5 7.20979 2.21116 5.4929 3.47703 4.22703C4.7429 2.96116 6.45979 2.25 8.25 2.25H9",
		fill: "none",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.5 23.25V19.5",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M20.25 0.75V8.25",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9 0.75V8.25",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15 19.5H22.5",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}));
});
export default SvgPipeline;
